var data = {
	"body": "<path class=\"clr-i-solid clr-i-solid-path-1\" d=\"M10 5.2h18v1.55H10z\" fill=\"currentColor\"/><path class=\"clr-i-solid clr-i-solid-path-2\" d=\"M29 8H9.86A1.89 1.89 0 0 1 8 6a2 2 0 0 1 1.86-2H29a1 1 0 1 0 0-2H9.86A4 4 0 0 0 6 6a4.14 4.14 0 0 0 0 .49a1 1 0 0 0 0 .24V30a4 4 0 0 0 3.86 4H29a1 1 0 0 0 1-1V9.25v-.09v-.09A1.07 1.07 0 0 0 29 8z\" fill=\"currentColor\"/>",
	"width": 36,
	"height": 36
};
exports.__esModule = true;
exports.default = data;
